import React, { useState } from "react";

import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";

import "./styles.css";

const FormInput = ({ label, type, placeholder, extraClass = "", phone }) => {
  const [phoneNumber, setPhoneNumber] = useState();
  const isTextarea = type === "textarea";

  return (
    <div className={`form-input ${extraClass}`}>
      <label>{label}</label>
      <div className="input-wrapper">
        {phone ? (
          <PhoneInput
            placeholder={placeholder}
            defaultCountry="BR"
            value={phoneNumber}
            onChange={setPhoneNumber}
            international={true}
            withCountryCallingCode={true}
          />
        ) : isTextarea ? (
          <textarea placeholder={placeholder} />
        ) : (
          <input type={type} placeholder={placeholder} />
        )}
      </div>
    </div>
  );
};

export default FormInput;
